import {
  Box,
  Typography,
  Button,
  Snackbar,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { useShipped } from "../hooks/logic/useShipped";
import { Shipped as styles } from "./ShippedStyle";
import SearchByGenre from "../components/SearchByGenre";
import UserFilterSelect from "../components/UserFilter";
import ProductInfoDialog from "../components/ProductInfoDialog";
import ShippedTable from "../components/Shipped/ShippedTable";
import ShipmentDialog from "../components/ShipmentDialog";

const Shipped = () => {
  const {
    inputRef,
    loginUser,
    ShippedList,
    userOptions,
    selectedUserId,
    handleUserChange,
    checkedIds,
    handleCheckChange,
    searchGenres,
    selectedGenreId,
    setSelectedGenreId,
    focusInputField,
    handleGenreChange,
    searchKeyword,
    setSearchKeyword,
    searchItems,
    resetFilter,
    resetGenreWord,
    handleKeywordChange,
    handleRowClick,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    planInfoDetail,
    handleBackStatus,
    isCancelLoading,
    // handlePageChange,
    totalListCount,
  } = useShipped();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ShipmentDialog
        open={detailDialogOpen}
        onClose={() => {
          // setSelectedParent(null);
          setDetailDialogOpen(false);
        }}
        statusId={5}
        planInfoDetail={planInfoDetail!}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          出荷済み
        </Typography>
      </Box>
      <Box py={0} px={0}>
        <Box display="flex" px={1} justifyContent="space-between">
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" gap={2} flexWrap="wrap" alignItems="flex-start">
              <UserFilterSelect
                options={userOptions}
                onSelect={handleUserChange}
                value={selectedUserId}
                sx={{ width: "300px" }}
              />
              <Button
                variant="outlined"
                onClick={async () => {
                  await resetFilter();
                }}
              >
                フィルター解除
              </Button>
            </Box>
            <Box display="flex" gap={2} mb={2} flexWrap="wrap">
              <SearchByGenre
                options={["プラン名", "問い合わせNO", "記入済"]}
                defaultGenre="プラン名"
                onGenreChange={handleGenreChange}
                searchKeyword={searchKeyword}
                onKeywordChange={setSearchKeyword}
                autoFocus={true}
                onEnter={focusInputField}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  searchItems(searchKeyword);
                }}
              >
                検索
              </Button>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-start"
            gap={4}
            mb={2}
          ></Box>
        </Box>

        <Box mt={2}>
          <ShippedTable
            data={ShippedList}
            totalListCount={totalListCount}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onParentRowClick={handleRowClick}
            handleBackStatus={handleBackStatus}
            // onPageChange={handlePageChange}
            loginUser={loginUser}
          ></ShippedTable>
        </Box>
        <Backdrop
          open={isCancelLoading}
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1000,
            color: "#fff",
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default Shipped;
